<script lang="ts">
  import Icon from './Icon.svelte';
  import { photoUrl } from './api';
  import { formatTypeLabel } from '~/shared/place-type.js';
  import type { TextSearchResult } from '~/shared/api.js';

  let {
    result,
    focused = false,
    onClick,
  }: {
    result: TextSearchResult;
    focused?: boolean;
    onClick: () => void;
  } = $props();

  const typeLabel = $derived(formatTypeLabel(result.category));
  const thumb = $derived(photoUrl(result.photoReference, 240));
</script>

<button
  type="button"
  class="row"
  class:row--focused={focused}
  data-place-id={result.placeId}
  onclick={onClick}
>
  <div class="thumb">
    {#if thumb}
      <img src={thumb} alt="" loading="lazy" />
    {:else}
      <Icon name="map-pin" size={20} />
    {/if}
  </div>
  <div class="info">
    <div class="name">{result.name}</div>
    <div class="meta">
      {#if result.rating !== null}
        <span class="rating">
          <Icon name="star" size={11} strokeWidth={2.25} />
          <span class="tabular-nums">{result.rating.toFixed(1)}</span>
        </span>
      {/if}
      {#if typeLabel}<span class="type">{typeLabel}</span>{/if}
    </div>
    {#if result.formattedAddress}
      <div class="address">{result.formattedAddress}</div>
    {/if}
  </div>
</button>

<style>
  .row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    background: transparent;
    border: 0;
    border-bottom: 1px solid var(--color-hairline-soft);
    text-align: left;
    cursor: pointer;
    transition: background 150ms ease;
    font: inherit;
    color: inherit;
  }
  .row:hover { background: var(--color-surface-soft); }
  .row:active { background: var(--color-surface-strong); }
  .row--focused { background: var(--color-primary-soft); }

  .thumb {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 8px;
    overflow: hidden;
    background: var(--color-surface-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-muted);
  }
  .thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .name {
    font-size: 15px;
    font-weight: 500;
    color: var(--color-ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .meta {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--color-muted);
  }
  .rating {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    color: var(--color-ink);
    font-weight: 500;
  }
  .type {
    display: inline-block;
    padding: 1px 8px;
    background: var(--color-surface-soft);
    color: var(--color-ink);
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.5;
  }
  .address {
    font-size: 12px;
    color: var(--color-muted);
    line-height: 1.35;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
